<!-- Tabla de planes(afiliaciones) de organizador (Se usa en la vista src/views/admin/Home.vue)
    Solo se muestra en el dashboard de organización si es que existe algún plan(afiliación)
-->
<!-- El componente se tiene que mejorar para obtener los datos de los planes con una consulta directa con express y mongoose-->
<template>
  <v-row justify="center" class="elevation-2 pa-5" v-if="planData.length > 0">
    <v-col cols="12">
      <h2 class="headline font-weight-bold">Afiliaciones</h2>
      <v-divider></v-divider>
       <!-- CONTENIDO DE LA TABLA -->
      <v-data-table
        no-data-text="No hay datos disponibles."
        no-results-text="No hay datos disponibles."
        loading-text="Cargando datos..."
        class="table-header"
        :headers="affiliationsHeaders"
        :items="planData"
        :items-per-page="($vuetify.breakpoint.xsOnly)?3:6"
        :loading="loading"
        :header-props="{
          sortByText:'Ordenar por'
        }"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageAllText:'Todas',
        }"
      >
        <template v-slot:body="{items}">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="text-center"
              :class="[($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
            >
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[0].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.name}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[1].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="teal"
                    dark
                    @click.native.stop="details(item.id)"
                  >{{ item.affiliates }}</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[2].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="teal"
                    dark
                    @click.native.stop="details(item.id)"
                  >Ver afiliados</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[3].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        class="pointer"
                        color="blue"
                        dark
                        v-on="on"
                        v-clipboard:copy="shareItem(item.id)"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        Copiar URL
                      </v-chip>
                    </template>
                    <span>https://v2.wechamber.mx/afiliaciones/{{item.id}}</span>
                  </v-tooltip>
                </div>
              </td>

              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[4].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="orange"
                    dark
                    @click="editItem(item)"
                  >Editar</v-chip>
                </div>
              </td>

              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold v-data-table__mobile-row__header d-flex d-sm-none"
                >{{affiliationsHeaders[5].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    class="pointer"
                    color="red darken-4"
                    dark
                    @click="openDialog(item)"
                  >Eliminar</v-chip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- DIALOG PARA LA ELIMINACIÓN DE UN PLAN EN ESPECÍFICO -->
      <v-dialog v-if="deleteDialog" v-model="deleteDialog" width="500" overlay-opacity="0.2">
        <v-card>
          <v-card-title>
            <h2 class="title">¿Estás seguro de querer eliminar la afiliación?</h2>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">Cancelar</v-btn>
            <v-btn color="error" depressed @click="confirmPlanDelete">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      deleteDialog: false,
      loading: true,
      planData: [],
      selectedItem: {},
      affiliationsHeaders: [
        { align: "center", text: "Nombre", value: "name" },
        // { text: "Fecha de vencimiento", value: "date" },
        { align: "center", text: "Afiliados", value: "affiliates" },
        { align: "center", text: "Ver afiliados", value: "viewAffiliates" },
        // { text: "Ventas", value: "sales" },
        { align: "center", text: "URL de afiliación", value: "url"},
        { align: "center", text: "Editar", value: "edit"},
        { align: "center", text: "Eliminar", value: "delete"}
        //{
        //  align: "center",
        //  text: "Acciones",
        //  width: "130px",
        //  sortable: false,
        //  value: "action"
        //}
      ]
    };
  },
  computed: {
    ...mapState("plan", ["plans"])
  },
  methods: {
    ...mapActions("plan", ["fetchUserPlans", "deletePlan"]),
    ...mapMutations("notifications", ["show"]),
     /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatPlanData() {
      await this.fetchUserPlans();
      this.planData = this.plans.map(plan => {
        return {
          id: plan.id,
          name: plan.name,
          affiliates: plan.affiliations.length
        };
      });
      this.loading = false;
    },

    /**
     * Función para ver los detalles de un plan en específico.
     * @param { string } id Identificador del plan.
     */
    details(id) {
      this.$router.push({ name: "admin-affiliates-details", params: { id } });
    },

    /**
     * Función para editar la información de un plan.
     * @param { Object.<string, string> } item Un objeto con los datos de un plan.
     */
    editItem(item) {
      this.$router.push({
        name: "admin-update-affiliation",
        params: { id: item.id }
      });
    },

    /**
     * Función para mostrar la ventana de confirmación para eliminar un plan.
     * @param { Object.<string, string> } item Un objeto con los datos de un plan.
     */
    openDialog(item) {
      this.deleteDialog = true;
      this.selectedItem = item;
    },

    /**
     * Función que elimina el plan seleccionado.
     */
    async confirmPlanDelete() {
      await this.deletePlan(this.selectedItem.id);
      await this.formatPlanData();
      this.deleteDialog = false;
    },

    /**
     * Función que obtiene la cantidad de afiliados de cada plan
     * @param { Array.<Object.<string, string>> } affiliations Arreglo con todas las transacciones de un plan.
     */
    getAffiliates(affiliations) {
      let filteredOrders = affiliations.filter(
        affiliation => affiliation.estatus != "IN_PROGRESS"
      );
      return filteredOrders.length;
    },

     /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatPlanData() {
      await this.fetchUserPlans();
      this.planData = this.plans.map(plan => {
        return {
          id: plan.id,
          name: plan.name,
          affiliates: this.getAffiliates(plan.affiliations)
          //affiliates: plan.affiliations.length
        };
      });
      this.loading = false;
    },
    /**
     * Función que devuelve un link para compartir la afiliación seleccionada.
     * @param { string } id Identificador único de un evento.
     */
    shareItem(id) {
      return `https://v2.wechamber.mx/afiliaciones/${id}`
    },

    /**
     * Función que muestra una notificación de exito al copiar un link para compartir.
     */
    onCopy: function(e) {
      this.show({ text: "¡Se ha copiado la url de afiliación al portapapeles! 😄" });
    },

    /**
     * Función que muestra una notificación de error en caso de que algo salga mal al 
     * copiar un link para compartir.
     */
    onError: function(e) {
      this.show({ text: "¡Hubo un problema al copiar la url de la afiliación!" });
    }
  },
  async mounted() {
    await this.formatPlanData();
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  td {
    width: 50px;
  }
}
.table-header >>> thead {
  background-color: rgb(231, 231, 231);
}
</style>>
